import Quill from 'quill'
import {isPlainObject} from 'lodash'

export const TEMPLATED_VALUE_PLACEHOLDER_DATA_PROP = 'documentProperty'
const Parchment = Quill.imports.parchment

export class TemplatedValueEditorPlaceholder extends Parchment.Embed {
    static tagName = 'span'
    static blotName = TEMPLATED_VALUE_PLACEHOLDER_DATA_PROP
    static className = TEMPLATED_VALUE_PLACEHOLDER_DATA_PROP

    // eslint-disable-next-line
    constructor(domNode) {
        super(domNode)
    }

    static register() {
        Quill.register(TemplatedValueEditorPlaceholder)
    }

    static create(field) {
        if (!isPlainObject(field)) {
            return
        }
        const text = field.label || ''
        const node = super.create(text)
        node.innerText = ' ' + text + ' '
        node.contentEditable = 'false'
        node.dataset[TEMPLATED_VALUE_PLACEHOLDER_DATA_PROP] = field.name
        return node
    }

    static value(node) {
        return _.get(node.childNodes, [0, 'textContent'], '')
    }
}
